import { render, staticRenderFns } from "./SplitPanelB.vue?vue&type=template&id=19b28c85&scoped=true&"
import script from "./SplitPanelB.vue?vue&type=script&lang=js&"
export * from "./SplitPanelB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b28c85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b28c85')) {
      api.createRecord('19b28c85', component.options)
    } else {
      api.reload('19b28c85', component.options)
    }
    module.hot.accept("./SplitPanelB.vue?vue&type=template&id=19b28c85&scoped=true&", function () {
      api.rerender('19b28c85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/modules/SplitPanelB.vue"
export default component.exports